"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcPeriodOnPeriod = void 0;
const date_fns_1 = require("date-fns");
const addMinutes_1 = __importDefault(require("date-fns/addMinutes"));
const _1 = require(".");
const period_1 = require("./period");
/**
 * Period上でPeriodを動かす
 * @param pxFromParentPeriodTop 親のtopからの距離
 * @param parentPeriod          親のParent
 * @param periodLengthMin       Periodの長さ(分)
 * @param roundMinute 　        丸め込む分
 * @param config                設定
 * @returns 計算したPeriod
 */
const calcPeriodOnPeriod = (pxFromParentPeriodTop, parentPeriod, periodLengthMinute, config, roundMinute = null) => {
    // 移動時間 = 移動距離 / 1分あたりの距離
    const moveMinutes = pxFromParentPeriodTop / config.heightPerMinute;
    // Periodの開始時刻 = 親のPeriodのStart + 移動時間
    let periodStart = (0, addMinutes_1.default)(parentPeriod.start, moveMinutes);
    // roundMinuteが指定されている場合は丸め込む
    if (roundMinute) {
        periodStart = (0, date_fns_1.roundToNearestMinutes)(periodStart, { nearestTo: roundMinute });
    }
    const periodEnd = (0, addMinutes_1.default)(periodStart, periodLengthMinute);
    const period = new period_1.Period(periodStart, periodEnd);
    return (0, _1.clampPeriod)(period, parentPeriod);
};
exports.calcPeriodOnPeriod = calcPeriodOnPeriod;
//# sourceMappingURL=calcPeriodOnPeriod.js.map